/* eslint-disable */
import axios from 'axios';
import { settings } from '@/settings';

const API_SERVER = settings.API_SERVER;
// console.log(API_SERVER, 'sdkljwlfhwffiwhn')
export const api_routes = {
  user: {
    login: 'user/login',
    signup: 'user/signup',
    me: 'user/me',
    get: 'user/'
  },
};
export const apiCall = ({ url, method, ...args }) =>
  new Promise((resolve, reject) => {
    const token = localStorage.getItem('user-token') || '';
    const serverUrl = API_SERVER + url;
    if (token) { axios.defaults.headers.common.Authorization = `Bearer ${token}`; }
    try {
      axios({
        method: method || 'get',
        url: serverUrl,
        ...args,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    } catch (err) {
      reject(new Error(err));
    }
  });
